import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService, EventManager } from 'ng-jhipster';
import { ClassType } from './class-type.model';
import { ClassTypeService } from './class-type.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'jhi-class-type-detail',
    templateUrl: './class-type-detail.component.html'
})
export class ClassTypeDetailComponent implements OnInit, OnDestroy {

    classType: ClassType;
    private subscription: any;
    private classTypeSubscription: Subscription;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private classTypeService: ClassTypeService,
        private eventManager: EventManager,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['classType']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });
        this.classTypeSubscription = this.eventManager
        .subscribe('classTypeListModification',
        (response) => {
            this.classType = response['content']['content'];
        });
    }

    load(id) {
        this.classTypeService.find(id).subscribe(classType => {
            this.classType = classType;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.classTypeSubscription.unsubscribe();
    }

    getStyle() {
        return  {'background-color': '#' + this.classType.backgroundColor};
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/class-type/class-type-detail.component.ts